import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { ApplicationEmptyState, BaasicButton, BaasicModal, EmptyState, BaasicDropdown, BaasicConfirmModal, BaasicConfirmModalNew, GlobalSignalRListener, NumericInput, GlobalItemChangeListener } from 'core/components';
import { PreviewLayout, Content } from 'core/layouts';
import { FacilityOrderNewFlowStatusBar } from "application/facility-order-new-flow-us-intake/components";
import { FacilityOrderNewFlowInventoryCountEditModal, FacilityOrderNewFlowInventoryCalculationVerificationModal, FacilityOrderNewFlowInventoryCalculationCutbackEditModal, FacilityOrderNewFlowInventoryCalculationProcessModal, FacilityOrderNewFlowMissingInventoryCountConfirmModal, FacilityOrderNewFlowInventoryEditEmergencySupplyDaysModal, FacilityOrderNewFlowExtraSuppliesAddModal } from "application/facility-order-new-flow-inventory/components";
import { toDate, toUTCDate } from 'core/utils';
import { observer } from "mobx-react";
import { Button } from "@progress/kendo-react-buttons";
import moment from 'moment';
import { Tooltip as ReactTooltip } from "react-tooltip";

function FacilityOrderNewFlowInventoryPreviewTemplate({ facilityOrderNewFlowInventoryPreviewViewStore, t }) {
    const {
        rootStore,
        loaderStore,
        facilityOrder,
        facilityInventoryCountHeader,
        isStatusBarVisible,
        openFacilityOrderNewFlowInventoryCountEditModal,
        facilityOrderNewFlowInventoryCountEditModal,
        facilityInventoryCalculation,
        facilityInventoryCalculationItemsGroup,
        createInventoryCalculation,
        isLoading,
        // editFacility,
        disabled,
        isDone,
        disabledCount,
        facilityOrderNewFlowInventoryCalculationVerificationModal,
        facilityOrderNewFlowInventoryCalculationCutbackEditModal,
        facilityOrderNewFlowInventoryCalculationProcessModal,
        openfacilityOrderNewFlowMissingInventoryCountConfirmModal,
        facilityOrderNewFlowMissingInventoryCountConfirmModal,
        statusConfirmModal,
        startInventoryCount,
        facilityOrderNewFlowInventoryEditEmergencySupplyDaysModal,
        openFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModal,
        facilityOrderNewFlowExtraSuppliesAddModal,
        refreshInventoryCalculation,
        signalRAction,
        pickTicketHeaderStatus,
        orderHistory,
        goToFacilityPreview,
        goToFacilityCalendar,
        downloadFacilityOrder,
        disabledItems,
        rebuildTooltip,
        updateInventoryCountInfoModal,
        extraSuppliesApprovalRequiredModal,
        openFacilityOrderNewFlowInventoryCalculationProcessModal,
        isApprovalRequired,
        isUpdateInventoryCountLoading,
        disabledSendOrder,
        isInventoryStepAllowed,
        changeStatusBarVisibility,
        copyFollowUpTemplateToClipboard,
        isInventoryFollowupEmail,
        isInventoryNotReceivedEmail,
        copyInventoryNotReceivedTemplateToClipboard,
        copyInventoryAsssitanceRequestEmail,
        isOngoingMissingInventoryEmail,
        openOngoingMissingInventoryWindow
    } = facilityOrderNewFlowInventoryPreviewViewStore;

    return (
        <PreviewLayout className="container container--new-flow" store={facilityOrderNewFlowInventoryPreviewViewStore} emptyRenderer={<ApplicationEmptyState />} layoutFooterVisible={false} loading={loaderStore.loading}>
            {facilityOrder &&
                <React.Fragment>
                    <ReactTooltip positionStrategy="fixed" id="warningMessageTooltip" place="top" />
                    <GlobalItemChangeListener isChanged={rebuildTooltip} />
                    {((pickTicketHeaderStatus && pickTicketHeaderStatus != "new") || (facilityOrder && facilityOrder.sendOrder)) &&
                        <div className='purches-notification'>
                            <div className='message__bar purches-notification-row'>
                                <span>{pickTicketHeaderStatus === "in-progress" ? "Purchasing is in progress. Don't make changes to the facility order." : pickTicketHeaderStatus === "completed" ? "Purchasing is complete. Don't make changes to the facility order." : "Billing is in Progress, any changes made must be reported to the biller."}</span>
                            </div>
                        </div>
                    }

                    <FacilityOrderNewFlowStatusBar facilityOrder={facilityOrder} title={`Facility Inventory: ${facilityOrder.facility.name} - DOS ${toDate(facilityOrder.dateOfService)}`} isOpen={isStatusBarVisible} changeStatusBarVisibility={() => changeStatusBarVisibility()} isInventoryStepAllowed={isInventoryStepAllowed}>
                        <div className="content__header__actions">
                            <ReactTooltip positionStrategy="fixed" id="historyTooltip" place="bottom" />
                            <Button className="btn btn--base btn--light u-mar--right--tny" icon="u-icon u-icon--med-lrg u-icon--us-history" onClick={() => orderHistory()} data-tooltip-content="Facility Order History" data-tooltip-id="historyTooltip" />

                            <ReactTooltip positionStrategy="fixed" id="facilityPreviewTooltip" place="bottom" />
                            <a className="btn btn--base btn--light u-mar--right--tny" target='_blank' data-tooltip-content="Facility Preview" data-tooltip-id="facilityPreviewTooltip" onClick={() => goToFacilityPreview()}><i className="u-icon u-icon--sml u-icon--preview--dark"></i></a>

                            <ReactTooltip positionStrategy="fixed" id="orderingTooltip" place="bottom" />
                            <a className="btn btn--base btn--light u-mar--right--tny" target='_blank' data-tooltip-content="Ordering Calendar" data-tooltip-id="orderingTooltip" onClick={() => goToFacilityCalendar()}><i className="u-icon u-icon--sml u-icon--schedules"></i></a>

                            <ReactTooltip positionStrategy="fixed" id="reportTooltip" place="bottom" />
                            <a className="btn btn--base btn--light" target='_blank' data-tooltip-content="FO Report Download" data-tooltip-id="reportTooltip" onClick={() => downloadFacilityOrder()}><i className="u-icon u-icon--sml u-icon--download--brand"></i></a>
                        </div>
                    </FacilityOrderNewFlowStatusBar>
                    <GlobalSignalRListener groupId={facilityOrder.id} rootStore={rootStore} action={signalRAction} />
                    {facilityInventoryCalculation && !isDone && facilityInventoryCalculation.isDirty &&
                        <div className="u-flex--space-between u-mar--top--med">
                            <div className="card card--outlined--featured card--outlined--note card--sml card--flex">
                                <div className="u-flex--space-between">
                                    <div>
                                        <i className="u-icon u-icon--sml u-icon--warning-triangle u-mar--right--sml"></i>Refresh the calculation to account for changes that have been made to the order.
                                    </div>
                                    <BaasicButton
                                        className='btn btn--base btn--primary u-align--h--right'
                                        label="Refresh Calculation"
                                        onClick={() => refreshInventoryCalculation()}
                                        disabled={disabledSendOrder || isLoading || isUpdateInventoryCountLoading}
                                        rotate icon={
                                            isLoading
                                                ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                                : 'u-display--none'
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    {facilityInventoryCalculation && isDone && facilityInventoryCalculation.isDirty &&
                        <div className="u-flex--space-between u-mar--top--med">
                            <div className="card card--outlined--featured card--outlined--note card--sml card--flex">
                                <div className="u-flex--space-between">
                                    <div>
                                        <i className="u-icon u-icon--sml u-icon--warning-triangle u-mar--right--sml"></i>The information may be inaccurate because changes have been made to the order.
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {facilityOrder.facilityInventoryCountHeaderId || facilityOrder.missingInventoryCount ?
                        <Content emptyRenderer={renderEmpty()}>
                            {facilityInventoryCountHeader &&
                                <div className="u-flex--space-between u-mar--top--med u-mar--bottom--med">
                                    <div className="u-flex--space-between u-mar--right--med">
                                        <div className="u-flex--space-between  card card--tny card--featured u-mar--right--med">
                                            <h4 className='u-mar--right--tny'>Count Date:</h4>
                                            <h4 className='type--wgt--bold'>{moment(facilityInventoryCountHeader.countDate).format("MM/DD/YY")}</h4>
                                            <BaasicButton
                                                className="btn btn--icon btn--icon--trans u-mar--left--tny"
                                                icon='u-icon u-icon--med u-icon--calendar--primary'
                                                disabled={disabledSendOrder || isLoading || disabledCount || isDone}
                                                label={t('FACILITY_INVENTORY.LIST.BUTTON.EDIT')}
                                                onlyIcon={true}
                                                onClick={() => openFacilityOrderNewFlowInventoryCountEditModal()}>
                                            </BaasicButton>
                                        </div>
                                        <div className='u-mar--right--med u-flex--default'>
                                            <label className="type--base type--narrow type--color--opaque">Emergency Supply Days: </label>
                                            <p className="u-mar--left--tny type--wgt--bold type--lh--1">{facilityOrder.facility.emergencySupplyDays}</p>
                                            <a className="u-mar--left--tny" target='_blank' onClick={() => { disabledSendOrder ? () => { } : openFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModal() }} style={isDone ? {} : {}}><i className="u-icon u-icon--sml u-icon--edit-alt"></i></a>
                                        </div>

                                        <div className="card--tertiary__header__divider u-mar--right--med"></div>
                                        <div className='u-mar--right--med u-flex--default'>
                                            <label className="type--base type--narrow type--color--opaque">Delivery Date: </label><p className="u-mar--left--tny type--wgt--bold type--lh--1">{toUTCDate(facilityOrder.nextDeliveryDate)} </p>
                                        </div>
                                        <div className='u-align--h--right'></div>

                                    </div>
                                    <div>
                                        {!isDone &&
                                            <BaasicButton
                                                className={"btn btn--base btn--ghost u-mar--right--sml"}
                                                label={t('FACILITY_INVENTORY.FACILITY_SUPPLY.MISSING')}
                                                onClick={() => openfacilityOrderNewFlowMissingInventoryCountConfirmModal()}>
                                            </BaasicButton>
                                        }
                                    </div>
                                </div>
                            }
                            {facilityOrder.facilityInventoryCountHeaderId ?
                                <InventoryCountTable
                                    facilityOrderNewFlowInventoryPreviewViewStore={facilityOrderNewFlowInventoryPreviewViewStore}
                                    t={t}
                                />
                                :
                                <div>
                                    <div className="u-flex--space-between  u-mar--top--med"></div>
                                    {(isInventoryNotReceivedEmail || isOngoingMissingInventoryEmail) && <div className='type--right'>
                                        {isInventoryNotReceivedEmail && <BaasicButton className="btn btn--base btn--ghost u-mar--left--tny u-mar--bottom--sml" icon="u-icon u-icon--med u-icon--mail" label={"Notify Facility"} onClick={() => copyInventoryNotReceivedTemplateToClipboard()} />}
                                        {isInventoryNotReceivedEmail && <BaasicButton className="btn btn--base btn--ghost u-mar--left--tny u-mar--bottom--sml" icon="u-icon u-icon--med u-icon--mail" label={"Notify Admin"} onClick={() => copyInventoryAsssitanceRequestEmail()} />}
                                        {isOngoingMissingInventoryEmail && <BaasicButton className="btn btn--base btn--ghost u-mar--left--tny u-mar--bottom--sml" icon="u-icon u-icon--med u-icon--mail-send--new" label={"Multiple Inventories Not Received Assistance Request"} onClick={() => openOngoingMissingInventoryWindow()} />}
                                    </div>}
                                    <div className="u-flex--space-between u-mar--bottom--sml">
                                        <div className="card card--outlined--featured card--outlined--note card--sml card--flex">
                                            <div className="u-flex--space-between">
                                                <div>
                                                    <h4 className="type--wgt--medium u-mar--bottom--tny">{t('FACILITY_ORDER_NEW_FLOW_INVENTORY.PREVIEW.START_FACILITY_INVENTORY')}</h4>
                                                    <p><i className="u-icon u-icon--sml u-icon--warning-triangle u-mar--right--sml"></i>Inventory step has been skipped because the Missing Inventory was checked off. You can still start this step if you have received an inventory count.</p>
                                                </div>
                                                <BaasicButton className="btn btn--base btn--primary u-align--h--right" icon="u-icon u-icon--xsml u-icon--play" label={t('FACILITY_ORDER_NEW_FLOW_INVENTORY.PREVIEW.START_LABEL')} disabled={disabledSendOrder} onClick={() => startInventoryCount()} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                            {facilityInventoryCalculation && facilityInventoryCalculationItemsGroup &&
                                <React.Fragment>
                                    <InventoryCalculationCard
                                        facilityOrderNewFlowInventoryPreviewViewStore={facilityOrderNewFlowInventoryPreviewViewStore}
                                    />
                                    <div className="u-flex--space-between">
                                        <BaasicButton
                                            className="btn btn--base btn--primary u-align--h--right u-mar--bottom--sml"
                                            label="Process / Finish"
                                            onClick={() => openFacilityOrderNewFlowInventoryCalculationProcessModal()}
                                            disabled={disabledSendOrder || isLoading || disabled || Object.values(disabledItems).some(value => value)}
                                        />
                                    </div>

                                </React.Fragment>
                            }

                            {!facilityInventoryCalculation && facilityInventoryCountHeader &&
                                <div className="u-flex--space-between u-mar--bottom--sml">
                                    <BaasicButton className="btn btn--base btn--primary u-align--h--right" rotate icon={isLoading ? "u-icon u-icon--xmed u-icon--sync u-rotate--login" : "u-display--none"} label={t('FACILITY_ORDER_NEW_FLOW_INVENTORY.PREVIEW.BEGIN_INVENTORY_CALCULATION_LABEL')} onClick={() => createInventoryCalculation()} disabled={disabledSendOrder || isLoading || isUpdateInventoryCountLoading} />
                                </div>
                            }
                        </Content>
                        :
                        facilityOrder.facilityOrderStatuses.some(x => x.status.abrv === "us-intake") ?
                            <div className="u-mar--top--med">
                                {isInventoryFollowupEmail && <div className='type--right'>
                                    <BaasicButton className="btn btn--base btn--ghost u-mar--left--tny u-mar--bottom--sml" icon="u-icon u-icon--med u-icon--mail" label={"Inventory Follow-Up"} onClick={() => copyFollowUpTemplateToClipboard()} />
                                </div>}
                                <div className="card card--outlined--featured card--sml card--flex ">
                                    <div className="u-flex--space-between">
                                        <h4 className="type--wgt--medium type--narrow">{t('FACILITY_ORDER_NEW_FLOW_INVENTORY.PREVIEW.START_FACILITY_INVENTORY')}</h4>
                                        <div>
                                            <BaasicButton className="btn btn--link btn--link--underline u-align--h--right u-mar--right--lrg" label={"Missing Inventory Count"} disabled={disabledSendOrder} onClick={() => openfacilityOrderNewFlowMissingInventoryCountConfirmModal()} />
                                            <BaasicButton className="btn btn--base btn--primary u-align--h--right" icon="u-icon u-icon--xsml u-icon--play" label={t('FACILITY_ORDER_NEW_FLOW_INVENTORY.PREVIEW.START_LABEL')} disabled={disabledSendOrder} onClick={() => startInventoryCount()} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="u-flex--space-between u-mar--top--med">
                                <p className="u-mar--bottom--xsml">Inventory cannot be started or skipped because US Intake has not yet started.</p>
                                {isInventoryFollowupEmail && <div className='u-flex--default u-mar--left--auto'>
                                    <BaasicButton className="btn btn--base btn--ghost u-mar--left--tny u-mar--bottom--sml" icon="u-icon u-icon--med u-icon--mail" label={"Inventory Follow-Up"} onClick={() => copyFollowUpTemplateToClipboard()} />
                                </div>}
                            </div>
                    }
                </React.Fragment>
            }
            <BaasicModal modalParams={facilityOrderNewFlowInventoryCountEditModal} className="modal__content modal--med">
                <FacilityOrderNewFlowInventoryCountEditModal />
            </BaasicModal>
            <BaasicModal modalParams={facilityOrderNewFlowInventoryCalculationVerificationModal} className="modal__content modal--lrg">
                <FacilityOrderNewFlowInventoryCalculationVerificationModal />
            </BaasicModal>
            <BaasicModal modalParams={facilityOrderNewFlowInventoryCalculationCutbackEditModal} className="modal__content modal--xlrg">
                <FacilityOrderNewFlowInventoryCalculationCutbackEditModal />
            </BaasicModal>
            <BaasicModal modalParams={facilityOrderNewFlowInventoryCalculationProcessModal} className={isApprovalRequired ? 'modal__content modal--med' : 'modal__content modal--sml'}>
                <FacilityOrderNewFlowInventoryCalculationProcessModal />
            </BaasicModal>
            <BaasicModal modalParams={facilityOrderNewFlowMissingInventoryCountConfirmModal} className="modal__content modal--sml">
                <FacilityOrderNewFlowMissingInventoryCountConfirmModal />
            </BaasicModal>
            <BaasicModal modalParams={facilityOrderNewFlowInventoryEditEmergencySupplyDaysModal} className="modal__content modal--med">
                <FacilityOrderNewFlowInventoryEditEmergencySupplyDaysModal />
            </BaasicModal>
            <BaasicModal modalParams={facilityOrderNewFlowExtraSuppliesAddModal} className="modal__content modal--xxlrg">
                <FacilityOrderNewFlowExtraSuppliesAddModal />
            </BaasicModal>
            <BaasicConfirmModal modalParams={statusConfirmModal} />
            <BaasicConfirmModal modalParams={updateInventoryCountInfoModal} />
            <BaasicConfirmModalNew modalParams={extraSuppliesApprovalRequiredModal} />
        </PreviewLayout>
    )
}

FacilityOrderNewFlowInventoryPreviewTemplate.propTypes = {
    facilityOrderNewFlowInventoryPreviewViewStore: PropTypes.object.isRequired,
    t: PropTypes.func
};

const InventoryCountTable = observer(({ facilityOrderNewFlowInventoryPreviewViewStore, t }) => {
    const {
        facilityInventoryCountDetails,
        setCardVisibility,
        isOpenInventoryCount,
        isLoading,
        downloadInventoryCount,
        disabled,
        disabledCount,
        deleteInventoryCountDetail,
        addInventoryCountDetail,
        productStore,
        saveInventoryCountDetail,
        editInventoryCountDetail,
        updateInventoryCountDetail,
        facilityInventoryCalculation,
        refreshInventoryCalculation,
        isEdit,
        cancelInventoryCountChanges,
        editInventoryCount,
        isDone,
        uploadInventoryCount,
        updateInventoryCount,
        isUpdateInventoryCountLoading,
        disabledSendOrder
    } = facilityOrderNewFlowInventoryPreviewViewStore;

    return (
        <div className="card--primary card--med u-mar--top--med u-mar--bottom--med">
            <div className="u-flex--space-between">
                <i className="u-icon u-icon--lrg u-icon--list-check"></i>
                <h4 className="u-mar--left--tny type--wgt--medium">Inventory Count</h4>
                <a target='_blank' onClick={() => { setCardVisibility(true) }}><i className={"u-mar--left--xsml u-icon u-icon--med " + (isOpenInventoryCount ? "u-icon--arrow-up--primary" : "u-icon--arrow-down--primary")} /></a>
                <div className='u-align--h--right u-flex--default'>
                    {isOpenInventoryCount &&
                        <React.Fragment>
                            {facilityInventoryCalculation && !isEdit && !isDone &&
                                <BaasicButton
                                    className='btn btn--base btn--primary u-mar--right--sml'
                                    label="Edit"
                                    onClick={() => editInventoryCount()}
                                    disabled={disabledSendOrder || isLoading || disabled}
                                />
                            }
                            <a target='_blank' className='btn btn--base btn--grey u-mar--right--sml' style={isDone || disabledSendOrder ? { opacity: 0.5, cursor: 'default' } : {}} onClick={isDone || disabledSendOrder ? null : () => uploadInventoryCount()}>
                                <i className="u-icon u-icon--sml u-icon--upload"></i>
                            </a>
                            <a target='_blank' className='btn btn--base btn--grey' onClick={() => downloadInventoryCount()}>
                                <i className="u-icon u-icon--sml u-icon--download--brand"></i>
                            </a>
                        </React.Fragment>
                    }
                </div>
            </div>
            {isOpenInventoryCount &&
                <React.Fragment>
                    <div className='u-position--rel u-mar--top--med'>
                        <ReactTooltip positionStrategy="fixed" id="actionsTooltip" place="top" />
                        <div className='table--preview__wrapper'>
                            <table className="table--preview">
                                <thead>
                                    <tr>
                                        <th width="50%" className="type--left">ITEM NAME</th>
                                        <th width="15%" className="type--left">ITEM ID</th>
                                        <th width="10%" className="type--left">CASE QTY</th>
                                        <th width="10%" className="type--left">EA QTY</th>
                                        <th width="10%" className="type--left">TOTAL EA QTY</th>
                                        <th width="5%" className="type--right"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {facilityInventoryCountDetails && facilityInventoryCountDetails.map((item, index) => {
                                        return (
                                            item.action != "delete" ?
                                                <tr key={item.id}>
                                                    <td className='u-position--rel'>
                                                        {item.product ? item.product.description :
                                                            <BaasicDropdown
                                                                disabled={disabledSendOrder || isLoading || disabledCount || isDone}
                                                                store={productStore}
                                                                value={item.product}
                                                                className="input--table--sml"
                                                                onChange={(e) => { saveInventoryCountDetail(index, e.target.value) }}
                                                            />
                                                        }
                                                    </td>
                                                    <td>{item.product && item.product.itemId}</td>
                                                    <td className="table-col-input text-align-left">
                                                        <NumericInput
                                                            className="input--numeric--table"
                                                            disabled={disabledSendOrder || isLoading || disabledCount || isDone || !item.product || (facilityInventoryCalculation && !isEdit) || isUpdateInventoryCountLoading}
                                                            onClick={(e) => e.target.select()}
                                                            onChange={(e) => editInventoryCountDetail(index, e.target.value, 'caseQty')}
                                                            onBlur={(e) => updateInventoryCountDetail(index, e.target.value, 'caseQty')}
                                                            value={item.caseQty}
                                                            defaultValue={null}
                                                            min="0"
                                                            max={"999.99"}
                                                            spinners={false}
                                                            showLabel={false}
                                                        />
                                                    </td>
                                                    <td className="table-col-input text-align-left">
                                                        <NumericInput
                                                            className="input--numeric--table"
                                                            disabled={disabledSendOrder || isLoading || disabledCount || isDone || !item.product || (facilityInventoryCalculation && !isEdit) || isUpdateInventoryCountLoading}
                                                            onClick={(e) => e.target.select()}
                                                            onChange={(e) => editInventoryCountDetail(index, e.target.value, 'eachQty')}
                                                            onBlur={(e) => updateInventoryCountDetail(index, e.target.value, 'eachQty')}
                                                            value={item.eachQty}
                                                            defaultValue={null}
                                                            min="0"
                                                            max={"999.99"}
                                                            spinners={false}
                                                            showLabel={false}
                                                        />
                                                    </td>
                                                    <td>
                                                        {item.quantity}
                                                    </td>
                                                    <td className="type--right">
                                                        <BaasicButton
                                                            className="btn btn--icon is-delete"
                                                            icon='u-icon u-icon--delete u-icon--sml'
                                                            disabled={disabledSendOrder || isLoading || disabledCount || isDone || (facilityInventoryCalculation && !isEdit)}
                                                            label={t('FACILITY_INVENTORY.LIST.BUTTON.DELETE')}
                                                            onlyIcon={true}
                                                            onClick={() => { deleteInventoryCountDetail(index) }}>
                                                        </BaasicButton>
                                                    </td>
                                                </tr>
                                                : <React.Fragment></React.Fragment>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                    </div>
                    <div className='u-flex--default u-flex--space-between u-mar--top--med'>
                        {!isDone &&
                            <div>
                                <Button
                                    className="btn btn--base btn--grey is-brand-on-hover u-mar--right--sml"
                                    icon="u-icon u-icon--sml u-icon--plus"
                                    label="Add Inventory Count Item"
                                    onlyIcon={true}
                                    onClick={() => addInventoryCountDetail()}
                                    disabled={disabledSendOrder || isLoading || disabledCount || (facilityInventoryCalculation && !isEdit) || isUpdateInventoryCountLoading}
                                    data-tooltip-content="Manually Add Product"
                                    data-tooltip-id="actionsTooltip"
                                />
                                <Button
                                    className="btn btn--base btn--grey is-brand-on-hover u-mar--right--sml"
                                    icon="u-icon u-icon--sml u-icon--search--brand"
                                    onlyIcon={true}
                                    label="Update Inventory Count Item"
                                    onClick={() => { updateInventoryCount(true) }}
                                    disabled={disabledSendOrder || isLoading || disabledCount}
                                    data-tooltip-content="Check for additional Enteral Products"
                                    data-tooltip-id="actionsTooltip"
                                />
                            </div>
                        }
                        {!isDone && facilityInventoryCalculation && isEdit &&

                            <div>
                                <BaasicButton
                                    className='btn btn--base btn--ghost '
                                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                                    disabled={disabledSendOrder || isLoading || disabledCount}
                                    onClick={() => cancelInventoryCountChanges()}
                                />

                                <BaasicButton
                                    className='btn btn--base btn--primary u-mar--left--sml'
                                    label="Refresh Calculation"
                                    onClick={() => refreshInventoryCalculation()}
                                    disabled={disabledSendOrder || isLoading || isUpdateInventoryCountLoading}
                                    rotate icon={
                                        isLoading
                                            ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                            : 'u-display--none'
                                    }
                                />
                            </div>

                        }
                    </div>
                </React.Fragment>
            }
        </div>
    );
});

InventoryCountTable.propTypes = {
    t: PropTypes.func
};

const InventoryCalculationCard = observer(({ facilityOrderNewFlowInventoryPreviewViewStore }) => {
    const {
        setCardVisibility,
        isOpenInventoryCalculation
    } = facilityOrderNewFlowInventoryPreviewViewStore;

    return (
        <div className="card card--form card--primary card--med u-mar--bottom--med">
            <div className="u-flex--space-between">
                <i className="u-icon u-icon--lrg u-icon--table-view--primary"></i>
                <h4 className="u-mar--left--tny type--wgt--medium">Inventory Calculation</h4>
                <a target='_blank' onClick={() => { setCardVisibility(false) }}><i className={"u-mar--left--sml u-icon u-icon--med " + (isOpenInventoryCalculation ? "u-icon--arrow-up--primary" : "u-icon--arrow-down--primary")} /></a>
                <div className='u-align--h--right'></div>
            </div>
            {isOpenInventoryCalculation &&
                <div className='u-mar--top--med'>
                    <InventoryCalculationTable
                        // key={facilityOrder.facilityInventoryCountHeaderId}
                        facilityOrderNewFlowInventoryPreviewViewStore={facilityOrderNewFlowInventoryPreviewViewStore}
                        isCutback={true}
                    />

                    <InventoryCalculationTable
                        // key={facilityOrder.facilityInventoryCountHeaderId}
                        facilityOrderNewFlowInventoryPreviewViewStore={facilityOrderNewFlowInventoryPreviewViewStore}
                        isCutback={false}
                    />

                    <InventoryCalculationTable
                        // key={facilityOrder.facilityInventoryCountHeaderId}
                        facilityOrderNewFlowInventoryPreviewViewStore={facilityOrderNewFlowInventoryPreviewViewStore}
                        isCutback={null}
                    />
                </div>
            }
        </div>
    );
});

InventoryCalculationCard.propTypes = {
};

const InventoryCalculationTable = observer(({ facilityOrderNewFlowInventoryPreviewViewStore, isCutback }) => {
    const {
        facilityInventoryCalculationItemsGroup,
        isLoading,
        disabled,
        editInventoryCalculationItem,
        updateInventoryCalculationItem,
        deleteInventoryCalculationItem,
        openFacilityOrderNewFlowInventoryCalculationVerificationModal,
        openFacilityOrderNewFlowInventoryCalculationCutbackEditModal,
        isDone,
        disabledItems,
        disabledSendOrder
    } = facilityOrderNewFlowInventoryPreviewViewStore;
    const type = isCutback ? "Cutback" : isCutback == false ? "ExtraSupplies" : "NoType";

    return (
        facilityInventoryCalculationItemsGroup && facilityInventoryCalculationItemsGroup[type] ?
            <div className="u-mar--top--med">
                <div className="type--wgt--medium u-mar--bottom--sml">{isCutback ? "Cutback" : isCutback == false ? "Extra Supplies" : "No Type"}</div>
                <div className='table--preview__wrapper'>
                    <table className="table--preview">
                        <thead>
                            <tr>
                                <th width="40%" className="type--left">ITEM NAME</th>
                                <th width="20%" className="type--left">ITEM ID</th>
                                <th width="10%" className="type--left">CALCULATED QTY</th>
                                <th width="10%" className="type--left">ACTUAL {isCutback ? "CB" : isCutback == false ? "ES" : "CB/ES"} QTY</th>
                                <th width="14%" className="type--left">QTY BEING SENT</th>
                                <th width="6%" className="type--right"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {facilityInventoryCalculationItemsGroup[type].map((item) => {
                                return (
                                    <tr key={item.id}>
                                        <td>{item.product}</td>
                                        <td>{item.itemId}</td>
                                        <td className='is-flex'>
                                            {item.calculatedQty}
                                            <div className='table-col-input text-align-right u-flex--space-between'>
                                                {!isDone && item.warningMessage &&
                                                    <div className="status--sqare__wrapper" data-tooltip-content={item.warningMessage} data-tooltip-id="warningMessageTooltip">
                                                        <i className="u-icon u-icon--sml u-icon--warning-triangle u-mar--right--sml"></i>
                                                    </div>
                                                }
                                                {!isDone && item.isOtherBottleUsedForCalculation && item.showIcon && isCutback &&
                                                    <div className="status--sqare__wrapper" data-tooltip-content={item.totalCutbackQty == 0 ? "The cutback was calculated but not applied because the extra stock is in a different bottle size. If you'd like to apply the cutback, you can do so manually." : "A larger cutback quantity was calculated but not applied because some of the extra stock is in a different bottle size. If you'd like to apply the additional cutback, you can do so manually."} data-tooltip-id="warningMessageTooltip">
                                                        <i className="u-icon u-icon--sml u-icon--warning-triangle u-mar--right--sml"></i>
                                                    </div>
                                                }
                                            </div>
                                        </td>
                                        <td className="table-col-input text-align-left">
                                            {isCutback ?
                                                <input
                                                    className="input input--sml"
                                                    disabled={disabledSendOrder || isLoading || disabled || disabledItems[item.id] === true}
                                                    onClick={(e) => e.target.select()}
                                                    onChange={(e) => editInventoryCalculationItem(item, e.target.value, 'totalCutbackQty')}
                                                    onBlur={() => updateInventoryCalculationItem(item, 'totalCutbackQty')}
                                                    value={item.totalCutbackQty}
                                                    type="number"
                                                    min="0"
                                                />
                                                :
                                                isCutback == false ?
                                                    <input
                                                        className="input input--sml"
                                                        disabled={disabledSendOrder || isLoading || disabled}
                                                        onClick={(e) => e.target.select()}
                                                        onChange={(e) => editInventoryCalculationItem(item, e.target.value, 'actualCutbackExtraSuppliesQuantity')}
                                                        onBlur={() => updateInventoryCalculationItem(item, 'actualCutbackExtraSuppliesQuantity')}
                                                        value={item.actualCutbackExtraSuppliesQuantity}
                                                        type="number"
                                                        min="0"
                                                    />
                                                    :
                                                    item.totalCutbackQty
                                            }
                                        </td>
                                        <td>
                                            {item.totalCaseAndEachQty}
                                        </td>
                                        <td className="table__body--data right">
                                            <div className="table__icons">
                                                <BaasicButton
                                                    className="btn btn--icon"
                                                    icon='u-icon u-icon--info u-icon--sml'
                                                    disabled={isLoading}
                                                    label='Info'
                                                    onlyIcon={true}
                                                    onClick={() => openFacilityOrderNewFlowInventoryCalculationVerificationModal(item)}>
                                                </BaasicButton>
                                                {!isCutback &&
                                                    <BaasicButton
                                                        className="btn btn--icon"
                                                        icon='u-icon u-icon--preview u-icon--sml'
                                                        disabled={isLoading}
                                                        label='Preview'
                                                        onlyIcon={true}
                                                        onClick={() => openFacilityOrderNewFlowInventoryCalculationCutbackEditModal(item, false)}>
                                                    </BaasicButton>
                                                }
                                                {isCutback &&
                                                    (isDone ?
                                                        <BaasicButton
                                                            className="btn btn--icon"
                                                            icon='u-icon u-icon--preview u-icon--sml'
                                                            disabled={isLoading}
                                                            label='Preview'
                                                            onlyIcon={true}
                                                            onClick={() => openFacilityOrderNewFlowInventoryCalculationCutbackEditModal(item, true)}>
                                                        </BaasicButton>
                                                        :
                                                        <BaasicButton
                                                            className="btn btn--icon"
                                                            icon='u-icon u-icon--edit-alt--grey u-icon--sml'
                                                            disabled={disabledSendOrder || isLoading || disabled || disabledItems[item.id]}
                                                            label='Edit'
                                                            onlyIcon={true}
                                                            onClick={() => openFacilityOrderNewFlowInventoryCalculationCutbackEditModal(item, true)}>
                                                        </BaasicButton>
                                                    )
                                                }
                                                {isCutback == false &&
                                                    <BaasicButton
                                                        className={"btn btn--icon" + (disabledSendOrder ? "" : " is-delete")}
                                                        icon='u-icon u-icon--delete u-icon--sml'
                                                        disabled={disabledSendOrder || isLoading || disabled}
                                                        label='Delete'
                                                        onlyIcon={true}
                                                        onClick={() => deleteInventoryCalculationItem(item)}>
                                                    </BaasicButton>
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            :
            <React.Fragment></React.Fragment>
    );
});
InventoryCalculationTable.propTypes = {
};

function renderEmpty() {
    return (
        <EmptyState
            title="FACILITY_INVENTORY_CALCULATION_ITEMS.LIST.EMPTY_STATE.TITLE"
        />
    );
}

export default defaultTemplate(FacilityOrderNewFlowInventoryPreviewTemplate);